/**
 * =============================================================================
 * ROASTBREW - PUBLIC WORDMARK
 * =============================================================================
 *
 * The RoastBrew lockup as it appears on every pre-auth screen.
 *
 * WHY IT EXISTS. Four screens each drew their own: AuthUI, VerifyEmailPage and
 * ResetPasswordPage used a layered-diamond SVG in a near-black rounded square,
 * UnsupportedBrowserGate used gold "RB" at 40px, and LandingPageObs used gold
 * "RB" at 34px with a tracked serif word. Same brand, four lockups — visible to
 * anyone who signs up, opens the verification email, and lands back on the
 * form. This is the landing page's version, which was the considered one, and
 * now it is the only one.
 *
 * Deliberately dumb: no router, no context, no props beyond presentation. It
 * renders inside UnsupportedBrowserGate, which sits above every provider in
 * the tree and can call none of them.
 *
 * November 2026: draws the brand lockup (signed R beside "RoastBrew.") from
 * BrandLockup, which is INLINE SVG — no image request, so the logo is on screen
 * in the same frame as the page and can never show as a broken image. Every
 * pre-auth screen is on T.ink, so this always uses the dark-background tone.
 * LandingPageObs's sticky nav and the first-paint splash in index.html draw the
 * same artwork.
 * =============================================================================
 */

import React from 'react';
import BrandLockup from './BrandLockup';

// Rendered height of the lockup. Width follows from the artwork's ~4.9:1
// aspect ratio (≈165px at md, ≈195px at lg).
const HEIGHT = { md: 34, lg: 40 };

export default function PublicMark({ size = 'md', style }) {
  const height = HEIGHT[size] || HEIGHT.md;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        zIndex: 1,
        ...style,
      }}
    >
      <BrandLockup tone="dark" height={height} />
    </div>
  );
}
